module.exports = __webpack_public_path__ + "img/image20@3x.e994d863.png";